"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipFab = exports.Tooltip = exports.Root = exports.Deal = exports.CatalogueLink = exports.CIRCLE_SIZE = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Deal = exports.Deal = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})({
  zIndex: 1
});
const CIRCLE_SIZE = exports.CIRCLE_SIZE = 45;
const CIRCLE_SIZE_SMALL = 35;
const FONT_SIZE = '2.9rem';
const FONT_SIZE_SUPER_SMALL = '2rem';
const FONT_SIZE_OFFER_SMALL = '2.3rem';
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isOffer,
  isSuper,
  offerLabelSmallerOnMobile,
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.offer.light,
  borderRadius: '50%',
  color: theme.palette.offer.main,
  display: 'flex',
  fontSize: FONT_SIZE,
  fontWeight: theme.typography.fontWeightBold,
  height: CIRCLE_SIZE,
  justifyContent: 'center',
  position: 'relative',
  width: CIRCLE_SIZE,
  ...(isSuper && offerLabelSmallerOnMobile && {
    fontSize: FONT_SIZE_SUPER_SMALL,
    height: CIRCLE_SIZE_SMALL,
    width: CIRCLE_SIZE_SMALL
  }),
  ...(isOffer && offerLabelSmallerOnMobile && {
    fontSize: FONT_SIZE_OFFER_SMALL,
    height: CIRCLE_SIZE_SMALL,
    width: CIRCLE_SIZE_SMALL
  }),
  [theme.breakpoints.up('md')]: {
    fontSize: FONT_SIZE,
    height: CIRCLE_SIZE,
    width: CIRCLE_SIZE
  }
}));
const Tooltip = exports.Tooltip = (0, _mui.styled)(_mui.Tooltip)(() => ({
  borderRadius: '100%',
  maxWidth: 300,
  textAlign: 'left',
  zIndex: 2
}));
const TooltipFab = exports.TooltipFab = (0, _mui.styled)(_mui.Fab, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['offerLabelSmallerOnMobile'])
})(({
  offerLabelSmallerOnMobile,
  theme
}) => ({
  boxShadow: 'none',
  height: 'inherit',
  minHeight: 'unset',
  width: 'inherit',
  svg: {
    fontSize: offerLabelSmallerOnMobile ? FONT_SIZE_OFFER_SMALL : FONT_SIZE
  },
  [theme.breakpoints.up('md')]: {
    svg: {
      fontSize: FONT_SIZE
    }
  }
}));
const CatalogueLink = exports.CatalogueLink = (0, _mui.styled)('a')(() => ({
  textDecoration: 'underline'
}));
